module.exports = __webpack_public_path__ + "img/compass-fill.e9b116d5.svg";